module.exports = __webpack_public_path__ + "fonts/LatoLatin-MediumItalic.60003618.woff2";